import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const translations = {
  en: {
    // Navigation
    home: "Home",
    aboutUs: "About Us",
    products: "Products",
    careers: "Careers",
    distributorEnquiry: "Distributor Enquiry",
    salesmanApplication: "Salesman Application",
    contact: "Contact",
    callNow: "Call Now",
    
    // Hero Section
    heroTitle: "Detergent & Cleaning Products Manufacturer in Kanpur",
    heroIntro: "Gupta Soap Grih Udyog is an ISO 9001:2015 Certified and MSME ZED Certified manufacturer of detergents and cleaning products based in Kanpur, Uttar Pradesh. Established in 1973, the company operates from its manufacturing facility located in Dadanagar Co-Operative Industrial Estate, Kanpur. With over five decades of industrial experience, the organization follows structured production practices, defined quality control systems, and disciplined manufacturing standards to ensure consistent product performance.",
    
    // Product Overview
    productOverview: "Our Product Range",
    tcmPowder: "T.C.M.® Detergent Powder",
    tcmSoap: "T.C.M.® & Jabaj® Detergent Soap",
    tcmSoapOnly: "T.C.M.® Detergent Soap",
    jabajSoapOnly: "Jabaj® Detergent Soap",
    oilBasedSoap: "Oil Based Laundry Soap",
    liquidProducts: "Liquid Cleaning Products",
    
    // Why Choose Us
    whyChooseUs: "Why Choose Us",
    experience: "Over Five Decades of Manufacturing Experience",
    isoCertified: "ISO 9001:2015 Certified Quality Management System",
    zedCertified: "MSME ZED Certified Enterprise",
    modernInfra: "Modern Production Infrastructure",
    qualityControl: "Strict Quality Control & Testing Procedures",
    structuredOps: "Structured Industrial Operations",
    
    // Manufacturing Section
    manufacturingTitle: "Manufacturing & Certifications",
    facilityTitle: "Manufacturing Facility",
    facilityDesc: "The company operates a dedicated manufacturing facility in Kanpur equipped with systematic production processes, supervised packaging operations, and controlled quality inspection procedures to maintain defined industrial standards.",
    certificationsTitle: "Certifications",
    isoDesc: "ISO 9001:2015 Certification reflects adherence to documented quality management systems and continuous process improvement.",
    zedDesc: "MSME ZED Certification represents commitment to responsible manufacturing practices and quality-focused production systems.",
    madeInIndia: "Made in India",
    madeInIndiaDesc: "Proudly manufactured in India, supporting the nation's vision of self-reliance and indigenous production capabilities.",
    vocalForLocal: "Vocal for Local",
    vocalForLocalDesc: "Committed to promoting local manufacturing and empowering Indian industries through quality products made by Indian hands.",
    
    // About Section
    aboutTitle: "About Us",
    aboutIntro: "Established in 1973, Gupta Soap Grih Udyog is a dedicated manufacturer of detergents and cleaning products based in Kanpur, Uttar Pradesh. With over five decades of manufacturing experience, the company has built a strong reputation for consistent quality, disciplined production practices, and long-standing industry presence.",
    aboutProducts: "The organization manufactures:",
    tcmPowderFull: "T.C.M.® Detergent Powder",
    tcmCakeFull: "T.C.M.® Detergent Cake",
    jabajCakeFull: "Jabaj® Detergent Cake",
    oilBasedSoapFull: "Oil Based Laundry Soap",
    liquidFull: "Liquid Cleaning Products including Hand Wash, Toilet Cleaner, White Phenyl, Black Phenyl and Floor Cleaner",
    aboutConclusion: "Operations are conducted under structured supervision to ensure uniformity, hygiene, and defined performance standards across all product categories.",
    
    // Products Section
    productsTitle: "Our Product Range",
    tcmPowderDesc: "Manufactured using carefully selected raw materials and controlled production processes to ensure effective cleaning performance and fabric care. Suitable for bucket and machine wash applications.",
    availableSizes: "Available Sizes",
    tcmSoapDesc: "Manufactured for effective manual washing with consistent structural strength and controlled lather formation.",
    available: "Available",
    greenVariant: "Green",
    blueVariant: "Blue",
    jabajSoapDesc: "Formulated for dependable cleaning performance and durability.",
    bartanBarIntro: "Give your utensils a sparkling shine with TCM Anti-Bacterial Bartan Bar. Specially formulated to remove tough grease and stains, it ensures deep cleaning while being gentle on your hands.",
    bartanBar: "T.C.M.® Bartan Bar",
    oilBasedDesc: "Produced using oil-based processing methods to enhance cleaning strength for heavy-duty washing applications.",
    liquidTitle: "Liquid Cleaning Products",
    handWash: "Hand Wash",
    handWashDesc: "Formulated for effective cleansing and hygiene maintenance.",
    toiletCleaner: "Toilet Cleaner",
    toiletCleanerDesc: "Designed for removal of stains and surface impurities.",
    whitePhenyl: "White Phenyl",
    whitePhenylDesc: "Manufactured for controlled floor hygiene and fragrance.",
    blackPhenyl: "Black Phenyl",
    blackPhenylDesc: "Suitable for strong cleaning requirements.",
    floorCleaner: "Floor Cleaner",
    floorCleanerDesc: "Developed for consistent cleaning performance across floor types.",
    
    // Careers Section
    careersTitle: "Careers",
    careersDesc: "Gupta Soap Grih Udyog offers structured career opportunities in manufacturing and sales operations. The company maintains a disciplined industrial environment and performance-based growth structure.",
    
    // Salesman Form
    salesmanTitle: "Salesman Application",
    fullName: "Full Name",
    fatherName: "Father's Name",
    phone: "Phone Number",
    email: "Email",
    address: "Address",
    cityState: "City / State",
    education: "Education Qualification",
    yearsExperience: "Years of Experience",
    previousCompany: "Previous Company",
    areaPreference: "Area Preference",
    expectedSalary: "Expected Salary",
    joiningDate: "Available Joining Date",
    uploadResume: "Upload Resume",
    uploadAadhar: "Upload Aadhar Card",
    uploadExpCert: "Upload Experience Certificate",
    submit: "Submit Application",
    
    // Distributor Form
    distributorTitle: "Distributor Enquiry",
    areaName: "Area Name",
    firmName: "Firm Name",
    ownerName: "Owner Name",
    gstin: "GSTIN",
    aadharNumber: "Aadhar Number",
    firmAddress: "Firm Address",
    godownAddress: "Godown Address",
    yearEstablished: "Year of Establishment",
    otherProducts: "Other Distribution Products",
    lastYearTurnover: "Last Year Turnover",
    deliveryMode: "Mode of Product Delivery",
    areasCovered: "Areas Covered",
    numSalesmen: "Number of Salesmen",
    bankName: "Bank Name",
    branchName: "Branch Name",
    accountNumber: "Account Number",
    uploadGst: "Upload GST Certificate",
    uploadTradeLicense: "Upload Trade License",
    uploadSupportingDocs: "Upload Supporting Documents",
    submitEnquiry: "Submit Enquiry",
    
    // Contact Section
    contactTitle: "Contact Our Manufacturing Facility in Kanpur",
    addressLabel: "Address",
    workingHours: "Working Hours",
    workingHoursValue: "Monday - Saturday: 9:00 AM - 6:00 PM",
    sendMessage: "Send Message",
    yourName: "Your Name",
    yourMessage: "Your Message",
    
    // Footer
    quickLinks: "Quick Links",
    followUs: "Follow Us",
    companyDetails: "Company Details",
    gstNo: "GST No.",
    udyamNo: "UDYAM Registration No.",
    toBeUpdated: "To be updated",
    trademark: "T.C.M.® and Jabaj® are registered trademarks of Gupta Soap Grih Udyog. Unauthorized use is strictly prohibited.",
    copyright: "All content and brand names displayed on this website are the intellectual property of Gupta Soap Grih Udyog.",
    allRights: "All Rights Reserved",
    
    // Common
    captchaVerify: "Verify you are human",
    required: "Required",
    optional: "Optional",
    success: "Success",
    error: "Error",
    submitting: "Submitting...",
  },
  hi: {
    // Navigation
    home: "होम",
    aboutUs: "हमारे बारे में",
    products: "उत्पाद",
    careers: "करियर",
    distributorEnquiry: "वितरक पूछताछ",
    salesmanApplication: "सेल्समैन आवेदन",
    contact: "संपर्क",
    callNow: "अभी कॉल करें",
    
    // Hero Section
    heroTitle: "कानपुर में डिटर्जेंट और सफाई उत्पाद निर्माता",
    heroIntro: "गुप्ता साबुन गृह उद्योग एक ISO 9001:2015 प्रमाणित और MSME ZED प्रमाणित डिटर्जेंट और सफाई उत्पादों का निर्माता है, जो कानपुर, उत्तर प्रदेश में स्थित है। 1973 में स्थापित, कंपनी दादानगर सहकारी औद्योगिक क्षेत्र, कानपुर में अपनी विनिर्माण सुविधा से संचालित होती है। पांच दशकों से अधिक औद्योगिक अनुभव के साथ, संगठन सुसंगत उत्पाद प्रदर्शन सुनिश्चित करने के लिए संरचित उत्पादन प्रथाओं, परिभाषित गुणवत्ता नियंत्रण प्रणालियों और अनुशासित विनिर्माण मानकों का पालन करता है।",
    
    // Product Overview
    productOverview: "हमारी उत्पाद श्रृंखला",
    tcmPowder: "T.C.M.® डिटर्जेंट पाउडर",
    tcmSoap: "T.C.M.® और जबाज® डिटर्जेंट साबुन",
    tcmSoapOnly: "T.C.M.® डिटर्जेंट साबुन",
    jabajSoapOnly: "जबाज® डिटर्जेंट साबुन",
    oilBasedSoap: "तेल आधारित धोबी साबुन",
    liquidProducts: "तरल सफाई उत्पाद",
    
    // Why Choose Us
    whyChooseUs: "हमें क्यों चुनें",
    experience: "पांच दशकों से अधिक विनिर्माण अनुभव",
    isoCertified: "ISO 9001:2015 प्रमाणित गुणवत्ता प्रबंधन प्रणाली",
    zedCertified: "MSME ZED प्रमाणित उद्यम",
    modernInfra: "आधुनिक उत्पादन अवसंरचना",
    qualityControl: "सख्त गुणवत्ता नियंत्रण और परीक्षण प्रक्रियाएं",
    structuredOps: "संरचित औद्योगिक संचालन",
    
    // Manufacturing Section
    manufacturingTitle: "विनिर्माण और प्रमाणन",
    facilityTitle: "विनिर्माण सुविधा",
    facilityDesc: "कंपनी कानपुर में एक समर्पित विनिर्माण सुविधा का संचालन करती है जो व्यवस्थित उत्पादन प्रक्रियाओं, पर्यवेक्षित पैकेजिंग संचालन और परिभाषित औद्योगिक मानकों को बनाए रखने के लिए नियंत्रित गुणवत्ता निरीक्षण प्रक्रियाओं से सुसज्जित है।",
    certificationsTitle: "प्रमाणन",
    isoDesc: "ISO 9001:2015 प्रमाणन प्रलेखित गुणवत्ता प्रबंधन प्रणालियों और निरंतर प्रक्रिया सुधार के पालन को दर्शाता है।",
    zedDesc: "MSME ZED प्रमाणन जिम्मेदार विनिर्माण प्रथाओं और गुणवत्ता-केंद्रित उत्पादन प्रणालियों के प्रति प्रतिबद्धता का प्रतिनिधित्व करता है।",
    madeInIndia: "मेड इन इंडिया",
    madeInIndiaDesc: "गर्व से भारत में निर्मित, आत्मनिर्भरता और स्वदेशी उत्पादन क्षमताओं के राष्ट्र के दृष्टिकोण का समर्थन करते हुए।",
    vocalForLocal: "वोकल फॉर लोकल",
    vocalForLocalDesc: "भारतीय हाथों द्वारा बने गुणवत्ता उत्पादों के माध्यम से स्थानीय विनिर्माण को बढ़ावा देने और भारतीय उद्योगों को सशक्त बनाने के लिए प्रतिबद्ध।",
    
    // About Section
    aboutTitle: "हमारे बारे में",
    aboutIntro: "1973 में स्थापित, गुप्ता साबुन गृह उद्योग कानपुर, उत्तर प्रदेश में स्थित डिटर्जेंट और सफाई उत्पादों का एक समर्पित निर्माता है। पांच दशकों से अधिक विनिर्माण अनुभव के साथ, कंपनी ने सुसंगत गुणवत्ता, अनुशासित उत्पादन प्रथाओं और लंबे समय से उद्योग में उपस्थिति के लिए एक मजबूत प्रतिष्ठा बनाई है।",
    aboutProducts: "संगठन निर्माण करता है:",
    tcmPowderFull: "T.C.M.® डिटर्जेंट पाउडर",
    tcmCakeFull: "T.C.M.® डिटर्जेंट केक",
    jabajCakeFull: "जबाज® डिटर्जेंट केक",
    oilBasedSoapFull: "तेल आधारित धोबी साबुन",
    liquidFull: "तरल सफाई उत्पाद जिसमें हैंड वॉश, टॉयलेट क्लीनर, व्हाइट फिनाइल, ब्लैक फिनाइल और फ्लोर क्लीनर शामिल हैं",
    aboutConclusion: "सभी उत्पाद श्रेणियों में एकरूपता, स्वच्छता और परिभाषित प्रदर्शन मानकों को सुनिश्चित करने के लिए संरचित पर्यवेक्षण के तहत संचालन किया जाता है।",
    
    // Products Section
    productsTitle: "हमारी उत्पाद श्रृंखला",
    tcmPowderDesc: "प्रभावी सफाई प्रदर्शन और कपड़े की देखभाल सुनिश्चित करने के लिए सावधानीपूर्वक चयनित कच्चे माल और नियंत्रित उत्पादन प्रक्रियाओं का उपयोग करके निर्मित। बाल्टी और मशीन वॉश दोनों के लिए उपयुक्त।",
    availableSizes: "उपलब्ध आकार",
    tcmSoapDesc: "सुसंगत संरचनात्मक मजबूती और नियंत्रित झाग निर्माण के साथ प्रभावी मैनुअल धुलाई के लिए निर्मित।",
    available: "उपलब्ध",
    greenVariant: "हरा",
    blueVariant: "नीला",
    jabajSoapDesc: "विश्वसनीय सफाई प्रदर्शन और स्थायित्व के लिए तैयार।",
    bartanBarIntro: "TCM एंटी-बैक्टीरियल बर्तन बार से अपने बर्तनों को चमकदार बनाएं। कठिन ग्रीस और दाग हटाने के लिए विशेष रूप से तैयार, यह आपके हाथों पर कोमल रहते हुए गहरी सफाई सुनिश्चित करता है।",
    bartanBar: "T.C.M.® बर्तन बार",
    oilBasedDesc: "भारी-भरकम धुलाई के लिए सफाई शक्ति को बढ़ाने के लिए तेल-आधारित प्रसंस्करण विधियों का उपयोग करके उत्पादित।",
    liquidTitle: "तरल सफाई उत्पाद",
    handWash: "हैंड वॉश",
    handWashDesc: "प्रभावी सफाई और स्वच्छता रखरखाव के लिए तैयार।",
    toiletCleaner: "टॉयलेट क्लीनर",
    toiletCleanerDesc: "दाग और सतह की अशुद्धियों को हटाने के लिए डिज़ाइन किया गया।",
    whitePhenyl: "व्हाइट फिनाइल",
    whitePhenylDesc: "नियंत्रित फर्श स्वच्छता और सुगंध के लिए निर्मित।",
    blackPhenyl: "ब्लैक फिनाइल",
    blackPhenylDesc: "मजबूत सफाई आवश्यकताओं के लिए उपयुक्त।",
    floorCleaner: "फ्लोर क्लीनर",
    floorCleanerDesc: "सभी प्रकार के फर्श पर सुसंगत सफाई प्रदर्शन के लिए विकसित।",
    
    // Careers Section
    careersTitle: "करियर",
    careersDesc: "गुप्ता साबुन गृह उद्योग विनिर्माण और बिक्री संचालन में संरचित करियर के अवसर प्रदान करता है। कंपनी एक अनुशासित औद्योगिक वातावरण और प्रदर्शन-आधारित विकास संरचना बनाए रखती है।",
    
    // Salesman Form
    salesmanTitle: "सेल्समैन आवेदन",
    fullName: "पूरा नाम",
    fatherName: "पिता का नाम",
    phone: "फोन नंबर",
    email: "ईमेल",
    address: "पता",
    cityState: "शहर / राज्य",
    education: "शैक्षिक योग्यता",
    yearsExperience: "अनुभव के वर्ष",
    previousCompany: "पिछली कंपनी",
    areaPreference: "क्षेत्र प्राथमिकता",
    expectedSalary: "अपेक्षित वेतन",
    joiningDate: "उपलब्ध ज्वाइनिंग तारीख",
    uploadResume: "रिज्यूमे अपलोड करें",
    uploadAadhar: "आधार कार्ड अपलोड करें",
    uploadExpCert: "अनुभव प्रमाणपत्र अपलोड करें",
    submit: "आवेदन जमा करें",
    
    // Distributor Form
    distributorTitle: "वितरक पूछताछ",
    areaName: "क्षेत्र का नाम",
    firmName: "फर्म का नाम",
    ownerName: "मालिक का नाम",
    gstin: "GSTIN",
    aadharNumber: "आधार नंबर",
    firmAddress: "फर्म का पता",
    godownAddress: "गोदाम का पता",
    yearEstablished: "स्थापना का वर्ष",
    otherProducts: "अन्य वितरण उत्पाद",
    lastYearTurnover: "पिछले साल का टर्नओवर",
    deliveryMode: "उत्पाद वितरण का तरीका",
    areasCovered: "कवर किए गए क्षेत्र",
    numSalesmen: "सेल्समैन की संख्या",
    bankName: "बैंक का नाम",
    branchName: "शाखा का नाम",
    accountNumber: "खाता नंबर",
    uploadGst: "GST प्रमाणपत्र अपलोड करें",
    uploadTradeLicense: "व्यापार लाइसेंस अपलोड करें",
    uploadSupportingDocs: "सहायक दस्तावेज़ अपलोड करें",
    submitEnquiry: "पूछताछ जमा करें",
    
    // Contact Section
    contactTitle: "कानपुर में हमारी विनिर्माण सुविधा से संपर्क करें",
    addressLabel: "पता",
    workingHours: "कार्य समय",
    workingHoursValue: "सोमवार - शनिवार: सुबह 9:00 - शाम 6:00",
    sendMessage: "संदेश भेजें",
    yourName: "आपका नाम",
    yourMessage: "आपका संदेश",
    
    // Footer
    quickLinks: "त्वरित लिंक",
    followUs: "हमें फॉलो करें",
    companyDetails: "कंपनी विवरण",
    gstNo: "GST नंबर",
    udyamNo: "UDYAM पंजीकरण नंबर",
    toBeUpdated: "अपडेट किया जाना है",
    trademark: "T.C.M.® और जबाज® गुप्ता साबुन गृह उद्योग के पंजीकृत ट्रेडमार्क हैं। अनधिकृत उपयोग सख्त वर्जित है।",
    copyright: "इस वेबसाइट पर प्रदर्शित सभी सामग्री और ब्रांड नाम गुप्ता साबुन गृह उद्योग की बौद्धिक संपदा हैं।",
    allRights: "सर्वाधिकार सुरक्षित",
    
    // Common
    captchaVerify: "सत्यापित करें कि आप मानव हैं",
    required: "आवश्यक",
    optional: "वैकल्पिक",
    success: "सफलता",
    error: "त्रुटि",
    submitting: "जमा हो रहा है...",
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
